package xim.poc.game.configuration.v0.tactics

import xim.poc.audio.SystemSound
import xim.poc.game.QueryMenuOption
import xim.poc.game.QueryMenuResponse
import xim.poc.game.UiStateHelper
import xim.poc.game.configuration.v0.TacticsUnit
import xim.poc.game.configuration.v0.UnitId
import xim.poc.ui.ShiftJis

private enum class Mode {
    Selecting,
    Moving
}

class TacticsReorderUi(val parent: TacticsBookInteraction) {

    private var mode = Mode.Selecting
    private var swappingUnit: UnitId? = null

    fun push() {
        mode = Mode.Selecting
        UiStateHelper.openQueryMode(
            promptProvider = this::promptText,
            optionsProvider = this::options,
            drawFn = parent::drawUnit,
            callback = this::handleSelection,
            visibleOptions = 6,
        )
    }


    private fun promptText(): String {
        return when (mode) {
            Mode.Selecting -> "Move which unit?"
            Mode.Moving -> "Move ${ShiftJis.colorItem}${current()?.name}${ShiftJis.colorClear} above which unit?"
        }
    }

    private fun options(): List<QueryMenuOption> {
        return TacticsState.getPlayerUnits().map {
            val color = if (it.id == swappingUnit) { ShiftJis.colorItem } else { ShiftJis.colorWhite }
            QueryMenuOption("${color}${it.name}", it.id)
        } + QueryMenuOption("Cancel", -1)
    }

    private fun current(): TacticsUnit? {
        return TacticsState.getPlayerUnits().firstOrNull { it.id == swappingUnit }
    }

    private fun handleSelection(queryMenuOption: QueryMenuOption?): QueryMenuResponse {
        if (queryMenuOption == null) { return handleEsc() }
        if (queryMenuOption.value < 0) { return QueryMenuResponse.pop }

        return when (mode) {
            Mode.Selecting -> {
                mode = Mode.Moving
                swappingUnit = queryMenuOption.value
                QueryMenuResponse.noop(SystemSound.TargetCycle)
            }
            Mode.Moving -> {
                reorder(queryMenuOption.value)
                mode = Mode.Selecting
                swappingUnit = null
                QueryMenuResponse.noop(SystemSound.TargetConfirm)
            }
        }
    }

    private fun reorder(target: UnitId) {
        val current = swappingUnit ?: return
        TacticsState.reorder(unitToMoveId = current, unitToMoveAboveId = target)
    }

    private fun handleEsc(): QueryMenuResponse {
        if (mode == Mode.Moving) {
            mode = Mode.Selecting
            swappingUnit = null
            return QueryMenuResponse.noop(SystemSound.MenuClose)
        }

        parent.zone.portraitDummy.reset()
        return QueryMenuResponse.pop
    }

}